import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import {
  bumpMessageGroupListItem,
  normalizeGroupMessage,
  sendMessageGroupMessage,
  upsertMessageInPages,
} from "../actions/messageGroups.actions";
import { messageGroupsQueryKeys } from "../messageGroups.queryKeys";

export const useMessageGroupMutation = (groupUid?: string, companyId?: number | string | null) => {
  const token = sessionStorage.getItem("token");
  const queryClient = useQueryClient();
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const messagesMutation = useMutation({
    mutationFn: (messageData: any) => sendMessageGroupMessage(token, groupUid as string, messageData, effectiveCompanyId),
    onSuccess: (created) => {
      const message = normalizeGroupMessage(created);
      if (!message?.uid || !effectiveCompanyId) return;

      queryClient.setQueryData(messageGroupsQueryKeys.messages(effectiveCompanyId, groupUid), (old: any) =>
        upsertMessageInPages(old, message),
      );

      const preview = message.content?.text ?? message.content?.name ?? null;
      const lastMessageAt = message.createdAt ?? new Date().toISOString();
      queryClient.setQueryData(messageGroupsQueryKeys.list(effectiveCompanyId), (old: any) =>
        bumpMessageGroupListItem(old, groupUid as string, {
          lastMessage: preview,
          lastMessageAt,
          lastMessageSenderName: message.sender?.name ?? null,
          incrementUnread: false,
        }),
      );
    },
  });

  return { messagesMutation };
};
